import { module, bootstrap } from "angular";
import matchTileDirective from "../../partials/match-tiles/match-tile/match-tile.directive";
import sportIconDirective from "../../partials/sport-icon/sport-icon.directive";
import teamIconDirective from "../../partials/icons/team-icon/team-icon.directive";
import { addGTMTag, generalConfig, /*rollbarConfig*/ } from "../general";
import "jquery-ui/themes/base/all.css";
// import "jquery-ui/ui/widgets/datepicker";
import "./match-list.scss";
import { MatchService } from "../../services/match.service";
import { SportDataService } from "../../services/sport-data.service";
import flagIconDirective from "../../partials/icons/flag-icon/flag-icon.directive";
import { nthFilter } from "../../filters/nth.filter";
import { GeneralService } from "../../services/general.service";
import { BetService } from "../../services/bet.service";
import { BlockConfigurationObject } from "../../interfaces/block-configuration-object.interface";
import matchListBlockComponent from "./match-list.component";

function loadSingleSiMatchList(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		if (config.sportCode) {
			// remove case-sensitivity for sport codes
			config.sportCode = config.sportCode.toUpperCase();
			// determine target element
			if (!config.targetElementID) {
				config.targetElementID = "si-external-match-list";
			}
			const targetElement = document.getElementById(config.targetElementID);
			if (targetElement !== null) {
				if (config.debugMode) {
					targetElement.innerHTML = "Loading Match List Block...";
				}
		
				if (config.publicationTheme) {
					
					require("../../publisher-themes/" + config.publicationTheme + ".scss");
				}

				targetElement.innerHTML = "<si-external-match-list></si-external-match-list>";
	
				addGTMTag(config);

				module("siExternalMatchList", [require("angular-sanitize"), /* 'ngAnimate',*/ /*require("ng-rollbar")*/])
					.value("configurationObject", config)
					.value("apiDomain", process.env.API_DOMAIN)
					.constant("blockDomain", process.env.BLOCK_DOMAIN)
					.constant("cdnDomain", process.env.CDN_DOMAIN)
					.service("sportDataService", SportDataService)
					.filter("nth", nthFilter)
					.service("generalService", GeneralService)
					.service("matchService", MatchService)
					.service("betService", BetService)
					.directive("teamIconSport", teamIconDirective)
					.directive("flagIconCountry", flagIconDirective)
					.directive("sportIconCode", sportIconDirective)
					.directive("matchTile", matchTileDirective)
					.config(generalConfig)
					.component("siExternalMatchList", matchListBlockComponent)
					// .config(["RollbarProvider", rollbarConfig]);

				bootstrap(targetElement, ["siExternalMatchList"], {strictDi: true});

				resolve();

			} else {
				reject(`Target element (#${config.targetElementID}) not found`);
			}
		} else {
			reject("Configuration object found, but required parameter 'sportCode' not found within");
		}
	});
}

function loadSiMatchList(config: BlockConfigurationObject): Promise<void> {
	return new Promise((resolve, reject) => {
		console.log("SI Loader script called");
		if (config) {
			if (Array.isArray(config)) {
				config.reduce((previousPromise, nextConfig) => {
					return previousPromise.then(() => {
						return loadSingleSiMatchList(nextConfig);
					}, (err) => {
						console.error("Match List Block failed: " + err);
						return loadSingleSiMatchList(nextConfig);
					});
				}, Promise.resolve()).then(resolve);
			} else {
				loadSingleSiMatchList(config).then(() => {
					console.log("Match List Block Successfully Loaded");
					resolve();
				}, (err) => {
					console.log(`Match List Block failed: ${err}`);
					reject(`Match List Block failed: ${err}`);
				});
			}
		} else {
			console.log("Configuration object (config) not found");
			reject("Configuration object (config) not found");
		}
	});
}

if (typeof window !== undefined) {
	window["loadSiMatchList"] = loadSiMatchList;
}
export { loadSiMatchList };